import { addTaskStates } from 'src/app/care/task.states';

/**
 * The angularjs states related to the module search
 */
searchStates.$inject = ['$stateProvider'];
export function searchStates($stateProvider) {
  $stateProvider
    .state('auth.alcmeon.search-legacy', {
      url: '/search',
      abstract: true,
      views: {
        'container@auth': {
          template: require('../../../ajs-app/components/search/search-legacy.html'),
          controller: 'SearchLegacyController'
        },
        'sub-nav@auth': {
          template: '' // a rule in core.scss makes an empty sub-nav disappear altogether
        }
      },
      resolve: {
        selectorsData: ['SearchFactory', '$stateParams', function (SearchFactory, $stateParams) {
          return SearchFactory.getSelectorsData($stateParams.companyId).then(function (response) {
            return response.data;
          });
        }],
        disableInPushMode: ['loggedUser', '$state', function (loggedUser, $state) {
          if (loggedUser.is_in_push_mode === 1) {
            $state.go('auth.alcmeon.after-login');
          }
        }],
      }
    })
    .state('auth.alcmeon.search-legacy.tasks', {
      url: '/tasks',
      params: {
        parameters: null,
      },
      resolve: {
        taskListConfiguration: [
          '$stateParams',
          '$translate',
          'loggedUser',
          'initFromSelf',
          function ($stateParams, $translate) {
            let parameters = {};
            if ($stateParams.parameters === null) {
              // someone is trying to navigate to this url by pasting the url in the browser
              // In this case, return something that makes it possible to not crash
              parameters = { states: [], sites_ids: [], tasks_ids: [] };
            } else {
              parameters = $stateParams.parameters;
            }
            return {
              parameters: parameters,
              title: $translate.instant('home/search/results'),
              isSearchPage: true,
            };
          },
        ],
      },
      views: {
        'search-results@auth.alcmeon.search-legacy': {
          template: require('src/ajs-app/components/tasks/tasks-list/tasks-list-ng/tasks-list-ng-search.html'),
          controller: 'TasksListNgController',
        },
      },
    })


    .state('auth.alcmeon.search', {
      url: '/search-tasks',
      abstract: true,
      views: {
        'container@auth': {
          template: require('../../../ajs-app/components/search/search.html'),
          controller: 'SearchController'
        },
        'sub-nav@auth': {
          template: '' // a rule in core.scss makes an empty sub-nav disappear altogether
        }
      },
    })
    .state('auth.alcmeon.search.tasks', {
      url: '/tasks',
      resolve: {
        taskListConfiguration: [
          '$translate',
          '$stateParams',
          'loggedUser',
          'initFromSelf',
          function ($translate, $stateParams) {
            let parameters = { states: [], sites_ids: [], tasks_ids: [] }
            try {
              const cache = localStorage.getItem(`${$stateParams.companyId}-search-page-filters`);
              parameters = JSON.parse(cache);
            } catch (error) {
              // Do nothing
            }

            return {
              parameters: parameters,
              isPendingAndOnHoldByBot: false,
              title: $translate.instant('home/search/results'),
              isSearchPage: true,
            };
          },
        ],
      },
      views: {
        'search-results@auth.alcmeon.search': {
          template: require('src/ajs-app/components/tasks/tasks-list/tasks-list-ng/tasks-list-ng-search.html'),
          controller: 'TasksListNgController',
        },
      },
    });

  addTaskStates($stateProvider, 'auth.alcmeon.search-legacy.tasks');
  addTaskStates($stateProvider, 'auth.alcmeon.search.tasks');
}
